// "Try the tabletop" (qa-runs 1163): the practice campaign of the active system — the one there is, or a new one the
// site makes with a party and two sample characters — and its table opened, where the tabletop lays out the
// ready-made scene. Offered only where the tabletop is configured.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../config/axios';
import { useSystem } from '../context/SystemContext';
import { vttConfigured } from '../config/vtt';
import { track } from '../utils/analytics';

export default function TryTabletopButton({ className = 'home-cta home-cta-outline', system: asked }) {
  const { system } = useSystem();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!vttConfigured()) return null;
  const go = async () => {
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      const { data } = await apiClient.post('/api/campaigns/practice', {}, { params: { system: asked || system } });
      track('practice-table');
      navigate(`/table/${data.id}`);
    } catch (err) {
      setError(err?.response?.data?.error === 'campaign_limit_reached'
        ? 'You have reached the campaign limit for this game system. Delete a campaign to make a practice table.'
        : 'The practice table could not be made just now. Try again in a moment.');
      setBusy(false);
    }
  };
  return (
    <>
      <button type="button" className={className} onClick={go} disabled={busy} data-testid="try-tabletop">
        {busy ? 'Opening…' : 'Try the tabletop'}
      </button>
      {error && <p className="dash-error" role="alert">{error}</p>}
    </>
  );
}

/** The marker a practice campaign carries wherever campaigns are listed. */
export const PracticeBadge = ({ campaign }) => (campaign && campaign.practice
  ? <span className="text-xs uppercase tracking-wide ml-2" style={{ color: 'var(--text-secondary)' }} data-testid="practice-badge">Practice</span>
  : null);
